<template>
  <div>
    <div class="filter-section">
      <a class="filter-collapse" @click="filterToggle = true" v-if="filterToggle === false">
        <i class="fas fa-search"></i>
      </a>
      <div class="filters" :class="{'is-active': filterToggle}">
        <button class="delete is-hidden-t" @click="filterToggle = false"></button>
        <div class="filter-content">
          <div class="columns is-multiline is-mobile is-variable is-5">
            <div class="column">
              <div class="slider">
                <label class="label">
                  Square Footage
                </label>
                <input type="text" class="range-slider" id="area" name="area_range" value="" ref="home-area"/>
              </div>
            </div>
            <div class="column">
              <div class="slider">
                <label class="label">
                  Price
                </label>
                <input type="text" class="range-slider home-area" id="price" name="price_range" value=""
                       ref="home-price"/>
              </div>
            </div>
            <div class="column is-narrow" v-if="filter">
              <label class="label">
                Bedrooms
              </label>
              <div class="buttons has-addons">
                <span class="button"
                      v-for="(bed, index) of ['Any','2+','3+','4+','5+']"
                      v-on:click="filterByBed(bed)"
                      v-bind:class="{ 'is-active': filter.bedArray.includes(bed) }"
                      :key="index">
                    {{ bed.toUpperCase() }}
                </span>
              </div>
            </div>
            <div class="column is-narrow" v-if="filter">
              <label class="label">
                Bathrooms
              </label>
              <div class="buttons has-addons">
                <span class="button"
                      v-for="(bath, index) of ['Any','2+','3+','4+']"
                      v-on:click="filterByBath(bath)"
                      v-bind:class="{ 'is-active': filter.bathArray.includes(bath) }"
                      :key="index">
                    {{ bath.toUpperCase() }}
                </span>
              </div>
            </div>

            <div class="column is-narrow" v-if="filter">
              <label class="label">
                Garages
              </label>
              <div class="buttons has-addons">
                    <span class="button"
                          v-for="(car, index) of ['Any', 2, 3]"
                          v-on:click="filterByCar(car)"
                          v-bind:class="{ 'is-active': filter.carArray.includes(car) }"
                          :key="index">{{ car }}</span>
              </div>
            </div>

            <div class="column is-narrow" v-if="filter">
              <label class="label">
                Stories
              </label>
              <div class="buttons has-addons">
                <span class="button"
                      v-for="(storey, index) of [1, 2]"
                      v-on:click="filterByStorey(storey)"
                      v-bind:class="{ 'is-active': filter.storeyArray.includes(storey) }"
                      :key="index">{{ storey }}</span>
              </div>
            </div>

            <div class="column is-narrow builder-width" v-if="filter && builders.length > 1">
              <label class="label">
                BUILDERS
              </label>
              <div class="builders-section">
                <div class="buttons has-addons">
                  <a class="button" :class="{'is-active': filter.buildersArray.includes(builder)}"
                     v-for="(builder, index) in builders" @click="filterByBuilders(builder)"
                     :key="index">
                    {{ builder }}
                  </a>
                </div>
              </div>
            </div>

            <div class="column is-narrow">
              <div class="sortby-section" v-if="filter">
                <label class="label">
                  SORT BY
                </label>
                <div>
                  <div class="buttons has-addons">
                    <span class="button"
                          v-on:click="sort('price-low')"
                          v-bind:class="{ 'is-active': filter.sortBy === 'price-low'}">
                        Low to High
                    </span>
                    <span class="button"
                          v-on:click="sort('price-high')"
                          v-bind:class="{ 'is-active': filter.sortBy === 'price-high'}">
                        High to Low
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-narrow" v-if="filter">
              <label class="label">
                &nbsp;
              </label>
              <span class="button is-small app-highlight" v-on:click="resetFilters()">RESTART</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filter from "@/model/HomeFilter";

export default {
  name: 'home-filter',
  props: {
    homeSummaryList: {
      type: Array
    }
  },
  data() {
    return {
      builders: [],
      filter: null,
      filterToggle: false
    }
  },
  mounted() {
    if (this.homeSummaryList.length) {
      this.initFilters();
    }
  },
  methods: {
 initFilters: function () {
  this.filter = filter;
  let minPrice = Number.MAX_SAFE_INTEGER;
  let maxPrice = 0;
  let minArea = Number.MAX_SAFE_INTEGER;
  let maxArea = 0;
  let minBed = Number.MAX_SAFE_INTEGER;
  let maxBed = 0;
  let minBath = Number.MAX_SAFE_INTEGER;
  let maxBath = 0;

  this.homeSummaryList.forEach(home => {
    if (!this.builders.includes(home.ownername)) {
      this.builders.push(home.ownername);
    }

    if (home.productsize && home.productsize > 0) {
      minArea = Math.min(minArea, home.productsize);
      maxArea = Math.max(maxArea, home.productsize);
    }

    if (home.productprice && home.productprice > 0) {
      minPrice = Math.min(minPrice, home.productprice);
      maxPrice = Math.max(maxPrice, home.productprice);
    }

    if (home.noofbedrooms && home.noofbedrooms > 0) {
      minBed = Math.min(minBed, home.noofbedrooms);
      maxBed = Math.max(maxBed, home.noofbedrooms);
    }

    if (home.noofbathrooms && home.noofbathrooms > 0) {
      minBath = Math.min(minBath, home.noofbathrooms);
      maxBath = Math.max(maxBath, home.noofbathrooms);
    }
  });

  if (minPrice === Number.MAX_SAFE_INTEGER) minPrice = 0;
  if (minArea === Number.MAX_SAFE_INTEGER) minArea = 0;
  if (minBed === Number.MAX_SAFE_INTEGER) minBed = 0;
  if (minBath === Number.MAX_SAFE_INTEGER) minBath = 0;

  this.filter.homePriceMin = minPrice;
  this.filter.homePriceMax = maxPrice;
  this.filter.homePriceFrom = minPrice;
  this.filter.homePriceTo = maxPrice;
  this.filter.homeAreaMin = minArea;
  this.filter.homeAreaMax = maxArea;
  this.filter.homeAreaFrom = minArea;
  this.filter.homeAreaTo = maxArea;
  this.filter.minBed = minBed;
  this.filter.maxBed = maxBed;
  this.filter.minBath = minBath;
  this.filter.maxBath = maxBath;
  this.filter.bedArray = ['Any'];
  this.filter.bathArray = ['Any'];
  this.filter.carArray = ['Any'];
  this.filter.storeyArray = [];
  this.filter.buildersArray = [];

  this.builders.sort();
  this.filterHomes();
  this.initRangeSliders();
},

    filterByBuilders: function (builder) {
      const index = this.filter.buildersArray.indexOf(builder);
      if (index < 0) {
        this.filter.buildersArray.push(builder);
      } else {
        this.filter.buildersArray.splice(index, 1);
      }
      this.filterHomes();
    },

    initRangeSliders: function () {
      this.priceSlider = jQuery(this.$refs['home-price']).ionRangeSlider({
        prefix: '$',
        type: "double",
        min: this.filter.homePriceMin,
        max: this.filter.homePriceMax,
        from: this.filter.homePriceFrom,
        force_edges: true,
        to: this.filter.homePriceTo,
        prettify_separator: ',',
        onFinish: (data) => {
          this.filter.homePriceFrom = data.from;
          this.filter.homePriceTo = data.to;
          this.filterHomes();
        }
      });

      this.areaSlider = jQuery(this.$refs['home-area']).ionRangeSlider({
        postfix: 'SQ FT',
        type: "double",
        min: this.filter.homeAreaMin,
        max: this.filter.homeAreaMax,
        from: this.filter.homeAreaFrom,
        to: this.filter.homeAreaTo,
        force_edges: true,
        prettify_separator: ',',
        onFinish: (data) => {
          this.filter.homeAreaFrom = data.from;
          this.filter.homeAreaTo = data.to;
          this.filterHomes();
        },
      });
    },

    filterByBed: function (bed) {
      if (!this.filter.bedArray.includes(bed)) {
        this.filter.bedArray = [];
        this.filter.bedArray.push(bed);
        if (bed === 'Any') {
          this.filter.bedFrom = 0;
          return this.filterHomes();
        }
        this.filter.bedFrom = parseInt(bed.split('+')[0], 10);
        this.filterHomes();
      }
    },

    filterByBath: function (bath) {
      if (!this.filter.bathArray.includes(bath)) {
        this.filter.bathArray = [];
        this.filter.bathArray.push(bath);
        if (bath === 'Any') {
          this.filter.bathFrom = 0;
          return this.filterHomes();
        }
        this.filter.bathFrom = parseInt(bath.split('+')[0], 10);
        this.filterHomes();
      }
    },

    filterByStorey: function (storey) {
      this.filter.storeyArray = [storey]
      this.filterHomes();
    },

    filterByCar: function (car) {
      if (!this.filter.carArray.includes(car)) {
        this.filter.carArray = [];
        this.filter.carArray.push(car);
        this.filterHomes();
      }
    },

    resetFilters: function () {
      this.filter.buildersArray = [];
      this.filter.bedArray = ['Any'];
      this.filter.bathArray = ['Any'];
      this.filter.storeyArray = [];
      this.filter.carArray = ['Any'];
      this.filter.bedFrom = 0;
      this.filter.bathFrom = 0;
      this.filter.tour = false;
      this.filter.homePriceFrom = this.filter.homePriceMin;
      this.filter.homePriceTo = this.filter.homePriceMax;
      this.filter.homeAreaFrom = this.filter.homeAreaMin;
      this.filter.homeAreaTo = this.filter.homeAreaMax;
      this.priceSlider.data('ionRangeSlider').update({
        from: this.filter.homePriceMin,
        to: this.filter.homePriceMax
      });
      this.areaSlider.data('ionRangeSlider').update({
        from: this.filter.homeAreaMin,
        to: this.filter.homeAreaMax
      });
      this.filter.quickMovein = false;
      this.filter.tour = false;
      this.filter.sortBy = '';
      this.filterHomes();
      this.sort(null);
    },

filterHomes: function () {
      this.filteredHomeList = [];
      this.homeSummaryList.forEach(home => {
        if (this.filter.buildersArray.length > 0 && (this.filter.buildersArray.indexOf(home.ownername) < 0)) {
          return;
        }
        if (home.noofbedrooms < this.filter.bedFrom) {
          return;
        }
        if (home.noofbathrooms < this.filter.bathFrom) {
          return;
        }
        if (home.productsize && home.productsize < this.filter.homeAreaFrom) {
          return;
        }
        if (home.productsize && home.productsize > this.filter.homeAreaTo) {
          return;
        }
        if (this.filter.homePriceFrom !== this.filter.homePriceMin && home.productprice < this.filter.homePriceFrom) {
          return;
        }
        if ( this.filter.homePriceTo !== this.filter.homePriceMax && home.productprice > this.filter.homePriceTo) {
          return;
        }
        if (filter.storeyArray.length > 0 && (filter.storeyArray.indexOf(home.noofstoreys) < 0)) {
          return;
        }
        if ((!filter.carArray.includes('Any')) && (filter.carArray.indexOf(home.noofcarparks) < 0)) {
          return;
        }
        this.filteredHomeList.push(home);
      });
      this.$emit('filteredHomes', this.filteredHomeList);
    },

    sort: function (sortValue) {
      if (sortValue) {
        this.filter.sortBy = sortValue;
      }
      switch (this.filter.sortBy) {
        case 'price-low':
          this.filteredHomeList = this.filteredHomeList.sort((a, b) => {
            const priceA = a.productprice;
            const priceB = b.productprice;
            if (priceA < priceB) {
              return -1;
            }
            if (priceA > priceB) {
              return 1;
            }
            return 0;
          });
          break;
        case 'price-high':
          this.filteredHomeList = this.filteredHomeList.sort((a, b) => {
            const priceA = a.productprice;
            const priceB = b.productprice;
            if (priceA > priceB) {
              return -1;
            }
            if (priceA < priceB) {
              return 1;
            }
            return 0;
          });
          break;
        default:
          this.filteredHomeList = this.filteredHomeList.sort((a, b) => {
            const nameA = a.designproductname.toLowerCase();
            const nameB = b.designproductname.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          break;
      }
      this.$emit('filteredHomes', this.filteredHomeList);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/home/HomeFilter.vue